import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import WalletContextProvider from "./WalletProvider";
import SimulacrumExplorerNavbar from "./components/SimulacrumExplorerNavbar";
import WalletExplorer from "./components/WalletExplorer";
import UserSolanaBalance from "./components/UserSolanaBalance";
import WalletHistory from "./components/WalletHistory";
import WalletDashboard from "./components/AccountDashboard";
import CreateNft from "./components/CreateNFT";
import CollectionView from "./components/CollectionView";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import DonationPage from "./components/DonationPage";
import TermsOfUse from "./components/TheCrumbExplorerTermsOfUse";
import PrivacyPolicy from "./components/TheCrumExplorerPrivacy";
import Copyright from "./components/TheCrumbExplorerCopyright";
import AdminDashboard from "./components/AdminDashboard";
import StyleShop from "./components/StyleShop";
import CrumbAboutPage from "./components/CrumbAboutPage";
import TokenDetail from "./components/TokenDetail";
import AudioNFTPlayerPage from "./components/AudioNFTPlayerPage";


// Create a QueryClient instance
const queryClient = new QueryClient();

function App() {
    return (
        <WalletContextProvider>
            <QueryClientProvider client={queryClient}>
                <Router>
                    <SimulacrumExplorerNavbar/>
                    <div className="App">
                        <h1>The Crumb - NFT Wallet Explorer</h1>
                        <Routes>
                            <Route path="/" element={<WalletDashboard />} />
                            <Route path="/audio" element={<AudioNFTPlayerPage />} />
                            <Route path="/audio/:walletAddress" element={<AudioNFTPlayerPage />} />

                            <Route path="/dashboard/:walletAddress" element={<WalletDashboard />} />

                            <Route path="/gratuity" element={<DonationPage />} />

                            <Route path="/dashboard" element={<WalletDashboard />} />
                            <Route path="/mint-nft" element={<CreateNft />} />
                            <Route path="/collection-view" element={<CollectionView />} />
                            <Route path="/legal/license" element={<TermsOfUse />} />
                            <Route path="/legal/privacy" element={<PrivacyPolicy />} />
                            <Route path="/legal/copyright" element={<Copyright />} />

                            <Route path="/about-crumb" element={<CrumbAboutPage />} />
                            <Route
                                path="token/:mint"
                                element={<TokenDetail />}
                            />

                            <Route path="/admin/styles" element={<AdminDashboard />} />
                            <Route path="/styles" element={<StyleShop />} />

                        </Routes>
                    </div>
                </Router>
            </QueryClientProvider>
        </WalletContextProvider>
    );
}

export default App;
